const initialState = {
  active: false,
};

const TOGGLE = 'navigation/TOGGLE';
const OPEN = 'navigation/OPEN';
const CLOSE = 'navigation/CLOSE';

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE:
      return {
        ...state,
        active: !state.active,
      };
    case OPEN:
      return {
        ...state,
        active: true,
      };
    case CLOSE:
      return {
        ...state,
        active: false,
      };

    default:
      return state;
  }
};

export const actionCreators = {
  toggle: () => ({ type: TOGGLE }),
  open: () => ({ type: OPEN }),
  close: () => ({ type: CLOSE }),
};

export const selectors = {
  isActive: state => state.navigation.active,
};



// WEBPACK FOOTER //
// ./src/state/ducks/navigation.js